import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';
import Main from '../components/Screens/Main';
import Section from '../components/Screens/Section';
import Video from '../utils/Vimeo';
import Markdown from '../components/Richtext/Markdown';
import CardEvent from '../components/Cards/CardEvent';
import Link from '../components/Global/Link';

// ====

const OurStory = (props) => {
  const { data, blok } = props;
  let pageData;
  if (data) {
    pageData = JSON.parse(data.index.content);
  } else {
    pageData = blok;
  }
  const openGraph = {
    type: 'website',
    title: pageData.page_title,
    description: pageData.page_intro,
    richtext: false,
    image: pageData.hero_image,
  };

  const [showAll, setShowAll] = useState(false);

  return (
    <Layout
      meta={pageData.meta}
      openGraph={openGraph}
      image={pageData.hero_image}
      background="blue"
    >
      <Hero title={pageData.messaging} />
      <Main>
        <Section marginBottom column>
          <div className="card">
            <div className="card-body">
              <h1 className="brand-font-caps">
                <span className="brand-font-outline">01</span>{' '}
                {pageData.page_title}
              </h1>
              <div
                className={`brand-text-columns ${
                  showAll
                    ? 'brand-content-overflow-open'
                    : 'brand-content-overflow-mobile'
                }`}
              >
                <Markdown>{pageData.page_intro}</Markdown>
              </div>
              <p className="text-center p-0 mt-3 brand-desktop-hidden">
                <Link
                  button
                  invert
                  icon={showAll ? 'chevron-up' : 'chevron-down'}
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? 'See less' : 'See more'}
                </Link>
              </p>
            </div>
          </div>
        </Section>

        <Section marginBottom column>
          <Video source={pageData.vimeo} />
        </Section>

        {pageData.events && (
          <article className="container-fluid pt-3 pb-3 pt-md-5 pb-md-5 brand-timeline-items">
            {pageData.events.map((event, idx) => {
              return (
                <CardEvent
                  title={event.event_title}
                  image={event.event_thumbnail}
                  date={event.event_date}
                  copy={event.event_copy}
                  idx={idx}
                />
              );
            })}
          </article>
        )}
      </Main>
    </Layout>
  );
};

export default OurStory;

// ====

export const QUERY = graphql`
  query OurStoryDefaultQuery {
    index: storyblokEntry(slug: { eq: "our-story" }) {
      content
    }

    # Grab news articles
    news: allStoryblokEntry(
      filter: { parent_id: { eq: 11989046 } }
      limit: 8
      sort: { fields: field_published_date_string, order: DESC }
    ) {
      nodes {
        name
        field_opening_copy_string
        slug
        field_thumbnail_image_string
        field_published_date_string
        field_category_string
      }
    }
  }
`;

OurStory.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

OurStory.defaultProps = {
  data: null,
};
